import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ProfilePictureDialogComponent } from '@core/user-profile/profile-picture-dialog/profile-picture-dialog.component';
import { UserService } from '@core/users/user.service';
import { Store } from '@ngrx/store';
import { DialogService } from '@platform/dialog/dialog.service';
import { ToastService } from '@platform/toast/toast.service';
import { RootState } from '@root/app.state';
import { filter, throwError } from 'rxjs';
import * as PlatformActions from '@platform/platform.actions';

@Component({
  selector: 'app-user-picture-editor',
  templateUrl: './user-picture-editor.component.html',
  styleUrls: ['./user-picture-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserPictureEditorComponent implements OnInit {
  @Input() userId: string;
  @Input() isMyProfile: boolean;
  @Input() disabled: boolean;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('thumbnailPhoto') thumbnailPhotoInitial: string;
  public thumbnailPhoto: string;

  constructor(
    private store$: Store<RootState>,
    private dialogService: DialogService,
    private userService: UserService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.thumbnailPhoto = this.thumbnailPhotoInitial;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openEditPictureDialog(event: any) {
    this.dialogService
      .openDialog<{ file: File }>(ProfilePictureDialogComponent, {
        width: '800px',
        autoFocus: false,
        disableClose: true,
        data: {
          thumbnailPhoto: this.thumbnailPhoto,
        },
      })
      .pipe(filter((data) => !!data))
      .subscribe((data) => {
        this.userService.postProfilePicture(this.userId, data.file as File).subscribe({
          next: (value) => {
            this.toastService.showSuccessToast('users.user-form.picture-success');
            this.thumbnailPhoto = value.thumbnailPhoto;
            if (this.isMyProfile) {
              this.store$.dispatch(PlatformActions.loadCurrentUserSucceeded({ user: value }));
            }
          },
          error: (err: HttpErrorResponse) => {
            if (err.status === 415) {
              this.toastService.showErrorToast('users.user-profile.errors.type');
              return;
            }
            if (err.status === 413) {
              this.toastService.showErrorToast('users.user-profile.errors.size');
              return;
            }
            if (err.status === 412) {
              this.toastService.showErrorToast('users.user-profile.errors.ratio');
              return;
            }
            throwError(() => err);
          },
        });
      });
  }
}
